import React, { Suspense } from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
} from '@mui/material';
import FilterListRoundedIcon from '@mui/icons-material/FilterListRounded';
const FilterDialog = ({
  buttonLabel = 'Filtre',
  title = 'Filtre',
  children = null,
  onSubmit = null,
  buttonProps = {},
}) => {
  const [open, setOpen] = React.useState(false);

  const openDialog = () => setOpen(true);
  const closeDialog = () => setOpen(false);

  const handleSubmit = () => {
    if (onSubmit) onSubmit();
    closeDialog();
  };

  return (
    <>
      <Button
        startIcon={<FilterListRoundedIcon />}
        variant="outlined"
        size="small"
        onClick={openDialog}
        {...buttonProps}
        data-testid="open-filter-dialog"
        sx={{
          borderRadius: 2,
          borderColor: 'divider',
          backgroundColor: 'background.paper',
          textTransform: 'none',
          p: 0.9,
          color: 'text.primary',
        }}
      >
        {buttonLabel}
      </Button>

      <Dialog
        open={open}
        onClose={closeDialog}
        maxWidth="lg"
        fullWidth
        sx={{ minHeight: 500 }}
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent dividers>
          <Suspense fallback={<div>Loading...</div>}>
            <Stack spacing={2}>{children}</Stack>
          </Suspense>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog} data-testid="filter-cancel">
            Afbryd
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            data-testid="filter-submit"
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default FilterDialog;
